export const CLUB_ID = "rrc-pickle";
export const APP_CLUB_ID = "rrc-pickle";
export const CLUB_NAME = "RRC Pickleball";
export const THEME_COLOR = "#8CBCE4";
export const BOTTOM_NAV_HEIGHT = 56;

// export const LEVELS = [
//     { value: 7, label: "DUPR 4.5 +" },
//     { value: 6, label: "DUPR 4.0 +" },
//     { value: 5, label: "DUPR 3.5 +" },
//     { value: 4, label: "DUPR 3.0 +" },
//     { value: 3, label: "DUPR 2.5 +" },
// ];
export const LEVELS = [
    { value: 7, label: "High Int" },
    { value: 6, label: "Intermediate" },
    { value: 5, label: "Low Int" },
    { value: 4, label: "Beginner" },
    { value: 3, label: "Novice" },
    { value: 2, label: "First Time" },
];
export const LEVELS_MAP = Object.fromEntries(
    LEVELS.map(item => [item.value, item.label])
);
export const levelColor = (level) => {
    const colors = ["#e6d4f9", "#c4dcf7", "#d1faff", "#d4f4dd", "#fff8b0", "#fce8b2", "#f8d7da"];
    return colors[Math.min(level - 1, colors.length - 1)];
};